import FullPageLayout from './layouts/FullPage';
import Review from './pages/Review';
import Errors from './pages/Errors';
import AcceptanceForm from './pages/AcceptanceForm';
import FullPageWidth from './layouts/FullPageWidth';

export default [
  {
    path: '/:token',
    exact: true,
    layout: FullPageLayout,
    component: Review
  },
    {
    path: '/:uuid/view',
    exact: true,
    layout: FullPageWidth,
    component: AcceptanceForm,
  },
  {
    layout: FullPageLayout,
    component: Errors
  }
];
